<template>
  <h4 class="d-flex align-items-center mb-0">
    <a href="tel:918606060" class="text-primary text-bold">
      <feather-icon
        icon="PhoneCallIcon"
        size="21"
        class="stroke-current"
      />
      <span class="ml-25">
      918606060
    </span>
    </a>
  </h4>
</template>

<script>
export default {
  name: 'Contact',
}
</script>

<style scoped>

</style>
